import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function NaviMumbaiCorporateCabService() {



    const cardData = {





keyword: "Navi Mumbai Corporate Cab Service",

headingDescription: "Shreesha Tours & Travels provides professional Navi Mumbai Corporate Cab Service for companies, IT firms, MNCs, corporate employees, business executives, and organizations requiring reliable employee transportation solutions. We offer dedicated corporate travel services with chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for office transfers, client meetings, business events, airport travel, and employee pickup and drop. With experienced drivers, well-maintained vehicles, punctual service, transparent billing options, customized travel plans, and 24/7 support, we ensure safe, comfortable, and efficient corporate transportation across Navi Mumbai and nearby business destinations.",

topPlaces: [
  {
    title: "Navi Mumbai to Airoli Knowledge Park",
    description: "Airoli Knowledge Park is one of Navi Mumbai's major IT and corporate hubs, hosting several technology companies, business centers, and commercial offices. Many employees and executives require daily transportation from different areas of Mumbai and Navi Mumbai. Corporate cab services provide scheduled pickup, comfortable rides, and reliable office commute solutions for companies operating in this region."
  },
  {
    title: "Navi Mumbai to Mahape MIDC",
    description: "Mahape MIDC is a prominent industrial and IT zone in Navi Mumbai known for corporate offices, technology parks, manufacturing units, and business establishments. Companies often require employee transportation, guest travel, and executive cab facilities. Corporate cab services ensure smooth connectivity with professional drivers and well-maintained vehicles."
  },
  {
    title: "Navi Mumbai to Vashi Business District",
    description: "Vashi is one of Navi Mumbai's busiest commercial areas, featuring corporate offices, business centers, shopping complexes, and conference venues. Corporate travelers frequently visit Vashi for meetings and professional work. Dedicated cab services help businesses manage employee travel and executive transportation with flexible scheduling."
  },
  {
    title: "Navi Mumbai to Belapur CBD",
    description: "CBD Belapur is an important business district of Navi Mumbai with government offices, corporate buildings, banks, and commercial establishments. Companies require reliable transportation for employees, clients, and visitors. Corporate cab solutions offer convenient office transfers with punctual pickup and drop facilities."
  },
  {
    title: "Navi Mumbai to Taloja MIDC",
    description: "Taloja MIDC is a growing industrial area known for manufacturing companies, warehouses, and business operations. Organizations often need regular employee transportation services for staff movement. Corporate cab services provide cost-effective travel solutions with comfortable vehicles and professional chauffeurs."
  },
  {
    title: "Navi Mumbai to Turbhe MIDC",
    description: "Turbhe MIDC is an important industrial and commercial location in Navi Mumbai with offices, warehouses, and manufacturing units. Businesses prefer corporate cab services for employee movement, client visits, and official transportation requirements. Reliable cab providers ensure smooth daily operations with scheduled travel plans."
  },
  {
    title: "Navi Mumbai to Hinjawadi Pune",
    description: "Hinjawadi Pune is one of Maharashtra's largest IT destinations and home to Rajiv Gandhi Infotech Park, multinational companies, and technology firms. Corporate professionals often travel between Navi Mumbai and Hinjawadi for meetings and work purposes. Premium corporate cabs provide comfortable long-distance travel with flexible booking options."
  },
  {
    title: "Navi Mumbai to Pune Kharadi IT Hub",
    description: "Kharadi is a major IT and business destination in Pune, known for EON IT Park, commercial offices, and corporate campuses. Companies require dependable transportation for employees, executives, and business visitors. Corporate cab services offer professional travel management with comfortable vehicles and timely service."
  },
  {
    title: "Navi Mumbai to Mumbai BKC",
    description: "Bandra Kurla Complex is Mumbai's leading financial and corporate business district, hosting multinational companies, banks, and premium office spaces. Corporate travelers frequently travel between Navi Mumbai and BKC for meetings and events. Dedicated corporate cab services ensure smooth and productive business travel."
  },
  {
    title: "Navi Mumbai to Mumbai Airport",
    description: "Mumbai Airport is a key travel point for corporate executives, international visitors, and business professionals. Companies require reliable airport transfer solutions for employees, guests, and clients. Corporate airport cab services provide flight-time coordination, professional drivers, and comfortable vehicles for stress-free travel."
  }
],


"services": [
  {
    "name": "Corporate Cab Service in Navi Mumbai",
    "description": "Choose Corporate Cab Service in Navi Mumbai for reliable employee transportation, business travel, and office commute solutions. Get professionally managed cab services with experienced chauffeurs, well-maintained AC vehicles, flexible schedules, and customized travel plans for companies, startups, and corporate offices."
  },
  {
    "name": "Corporate Taxi Service Navi Mumbai",
    "description": "Book Corporate Taxi Service Navi Mumbai for comfortable and punctual office transportation. Our corporate taxi solutions provide dedicated vehicles, professional drivers, timely pickups, and smooth travel experiences for employees, executives, and business professionals."
  },
  {
    "name": "Corporate Car Rental Navi Mumbai",
    "description": "Hire Corporate Car Rental Navi Mumbai for business meetings, client visits, employee travel, and corporate events. Choose from Sedan, SUV, Innova, Innova Crysta, Kia Carens, and premium vehicles with chauffeur-driven services."
  },
  {
    "name": "Corporate Cab Booking Navi Mumbai",
    "description": "Complete Corporate Cab Booking Navi Mumbai with easy reservations, flexible packages, and reliable transportation services. Get customized cab solutions for daily office travel, employee pickup-drop, meetings, and corporate requirements."
  },
  {
    "name": "Navi Mumbai Office Cab Service",
    "description": "Book Navi Mumbai Office Cab Service for safe and comfortable employee commuting. Enjoy scheduled pickup and drop facilities with trained drivers, GPS-enabled vehicles, and professional transportation management for offices."
  },
  {
    "name": "Corporate Travel Cab Navi Mumbai",
    "description": "Choose Corporate Travel Cab Navi Mumbai for business trips, meetings, conferences, and official travel. Experience comfortable rides with premium vehicles, professional chauffeurs, and dependable corporate transportation support."
  },
  {
    "name": "Business Travel Cab Navi Mumbai",
    "description": "Hire Business Travel Cab Navi Mumbai for executives, professionals, and corporate guests. Get timely airport transfers, meeting transportation, and intercity business travel with comfortable chauffeur-driven cars."
  },
  {
    "name": "Company Cab Service Navi Mumbai",
    "description": "Book Company Cab Service Navi Mumbai for employee transportation and regular office commuting needs. Get reliable vehicles, experienced drivers, fixed schedules, and customized plans suitable for companies of all sizes."
  },
  {
    "name": "Corporate Chauffeur Service Navi Mumbai",
    "description": "Choose Corporate Chauffeur Service Navi Mumbai for premium business travel with trained and professional chauffeurs. Enjoy safe, private, and comfortable transportation for executives, clients, and corporate guests."
  },
  {
    "name": "Corporate Transportation Navi Mumbai",
    "description": "Get Corporate Transportation Navi Mumbai services designed for employee mobility, office transfers, and business travel. We provide organized transportation solutions with multiple vehicle options and flexible service plans."
  },
  {
    "name": "Corporate Cab Hire Navi Mumbai",
    "description": "Hire Corporate Cab Navi Mumbai for reliable office travel and business transportation. Enjoy affordable corporate packages, professional drivers, clean vehicles, and convenient pickup-drop services."
  },
  {
    "name": "Corporate Taxi Booking Navi Mumbai",
    "description": "Book Corporate Taxi Booking Navi Mumbai for hassle-free employee and business transportation. Get quick booking options, dedicated support, and comfortable taxis for daily office and corporate travel."
  },
  {
    "name": "Corporate Car Hire Navi Mumbai",
    "description": "Choose Corporate Car Hire Navi Mumbai for executive travel, business meetings, and company events. Select from premium chauffeur-driven cars with flexible rental options and professional service."
  },
  {
    "name": "Corporate Employee Cab Service Navi Mumbai",
    "description": "Book Corporate Employee Cab Service Navi Mumbai for safe and reliable staff transportation. Get scheduled employee pickup and drop solutions with comfortable vehicles and experienced drivers."
  },
  {
    "name": "Corporate Cab Service Near Navi Mumbai",
    "description": "Find Corporate Cab Service Near Navi Mumbai for convenient office transportation and employee travel solutions. Enjoy nearby pickup facilities, reliable service, and flexible corporate cab packages."
  },
  {
    "name": "Book Corporate Cab Navi Mumbai",
    "description": "Book Corporate Cab Navi Mumbai for professional office transportation with easy reservations and customized travel solutions. Suitable for employee commute, business meetings, airport transfers, and corporate events."
  },
  {
    "name": "Corporate Cab Service for Companies Navi Mumbai",
    "description": "Corporate Cab Service for Companies Navi Mumbai provides dedicated transportation solutions for businesses. Get monthly plans, employee transport management, and reliable cab services designed according to company requirements."
  },
  {
    "name": "Corporate Cab Rental for Office Staff Navi Mumbai",
    "description": "Hire Corporate Cab Rental for Office Staff Navi Mumbai for convenient daily employee transportation. Enjoy scheduled routes, comfortable vehicles, professional drivers, and hassle-free office commute management."
  },
  {
    "name": "Corporate Cab Service Monthly Contract Navi Mumbai",
    "description": "Choose Corporate Cab Service Monthly Contract Navi Mumbai for long-term employee transportation solutions. Get affordable monthly packages, dedicated vehicles, planned routes, and reliable service support."
  },
  {
    "name": "Corporate Pickup Drop Cab Navi Mumbai",
    "description": "Book Corporate Pickup Drop Cab Navi Mumbai for smooth employee commuting between home and office locations. Enjoy punctual pickups, safe travel, and comfortable AC vehicles throughout the day."
  },
  {
    "name": "Corporate Employee Transport Navi Mumbai",
    "description": "Get Corporate Employee Transport Navi Mumbai services for efficient staff mobility. We provide organized pickup-drop solutions with professional drivers, multiple vehicle choices, and customized corporate travel plans."
  },
  {
    "name": "Corporate Cab Service 24x7 Navi Mumbai",
    "description": "Choose Corporate Cab Service 24x7 Navi Mumbai for round-the-clock employee and business transportation. Available for early morning shifts, night shifts, airport travel, and emergency corporate requirements."
  },
  {
    "name": "Corporate Cab for IT Companies Navi Mumbai",
    "description": "Book Corporate Cab for IT Companies Navi Mumbai for reliable employee transportation solutions. Ideal for IT parks, technology companies, and offices requiring safe daily commute services."
  },
  {
    "name": "Corporate Cab Service Vashi Navi Mumbai",
    "description": "Get Corporate Cab Service Vashi Navi Mumbai for office staff transportation, business travel, and executive movement. Enjoy professional cab solutions with flexible schedules and comfortable vehicles."
  },
  {
    "name": "Corporate Cab Service Belapur Navi Mumbai",
    "description": "Choose Corporate Cab Service Belapur Navi Mumbai for dependable corporate transportation. We provide employee pickup-drop, business travel, and customized cab rental services for companies."
  },
  {
    "name": "Corporate Cab Service Kharghar Navi Mumbai",
    "description": "Book Corporate Cab Service Kharghar Navi Mumbai for convenient office commuting and corporate travel. Get reliable transportation with trained chauffeurs and well-maintained vehicles."
  },
  {
    "name": "Corporate Cab Service Nerul Navi Mumbai",
    "description": "Hire Corporate Cab Service Nerul Navi Mumbai for professional employee transport and business travel solutions. Enjoy safe rides, punctual service, and flexible corporate packages."
  },
  {
    "name": "Corporate Cab Service Airoli Navi Mumbai",
    "description": "Choose Corporate Cab Service Airoli Navi Mumbai for employee transportation and IT company commute needs. Get efficient pickup-drop services with experienced drivers and comfortable vehicles."
  },
  {
    "name": "Corporate Cab Service Ghansoli Navi Mumbai",
    "description": "Book Corporate Cab Service Ghansoli Navi Mumbai for reliable office travel solutions. Suitable for companies, employees, and business professionals looking for safe and convenient transportation."
  },
  {
    "name": "Corporate Cab Service Panvel Navi Mumbai",
    "description": "Get Corporate Cab Service Panvel Navi Mumbai for employee transport, business travel, and office commute requirements. Enjoy dependable cab services with flexible booking options and professional chauffeurs."
  }
],
"tableData": [
  ["Corporate Cab Service in Navi Mumbai", "Corporate Taxi Service Navi Mumbai"],
  ["Corporate Car Rental Navi Mumbai", "Corporate Cab Booking Navi Mumbai"],
  ["Navi Mumbai Office Cab Service", "Corporate Travel Cab Navi Mumbai"],
  ["Business Travel Cab Navi Mumbai", "Company Cab Service Navi Mumbai"],
  ["Corporate Chauffeur Service Navi Mumbai", "Corporate Transportation Navi Mumbai"],
  ["Corporate Cab Hire Navi Mumbai", "Corporate Taxi Booking Navi Mumbai"],
  ["Corporate Car Hire Navi Mumbai", "Corporate Employee Cab Service Navi Mumbai"],
  ["Corporate Cab Service Near Navi Mumbai", "Book Corporate Cab Navi Mumbai"],
  ["Corporate Cab Service for Companies Navi Mumbai", "Corporate Cab Rental for Office Staff Navi Mumbai"],
  ["Corporate Cab Service Monthly Contract Navi Mumbai", "Corporate Pickup Drop Cab Navi Mumbai"],
  ["Corporate Employee Transport Navi Mumbai", "Corporate Cab Service 24x7 Navi Mumbai"],
  ["Corporate Cab for IT Companies Navi Mumbai", "Corporate Cab Service Vashi Navi Mumbai"],
  ["Corporate Cab Service Belapur Navi Mumbai", "Corporate Cab Service Kharghar Navi Mumbai"],
  ["Corporate Cab Service Nerul Navi Mumbai", "Corporate Cab Service Airoli Navi Mumbai"],
  ["Corporate Cab Service Ghansoli Navi Mumbai", "Corporate Cab Service Panvel Navi Mumbai"]
],




whychoose: [
  {
    WhyChooseheading: "Professional Navi Mumbai Corporate Cab Service",
    WhyChoosedescription: "Shreesha Travels provides reliable corporate cab services in Navi Mumbai for companies, employees, executives, business meetings, and client transportation. Our organized travel solutions help businesses manage daily commuting with comfort and punctuality."
  },
  {
    WhyChooseheading: "Dedicated Employee Transportation Solutions",
    WhyChoosedescription: "We offer customized employee pickup and drop services with planned routes, scheduled timings, and suitable vehicles to support companies with regular transportation requirements."
  },
  {
    WhyChooseheading: "Premium Cars for Executive Travel",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, and premium vehicles for executives, clients, and corporate guests."
  },
  {
    WhyChooseheading: "Airport & Business Travel Support",
    WhyChoosedescription: "Our corporate cabs are ideal for airport transfers, business meetings, conferences, corporate events, hotel transfers, and professional travel across Navi Mumbai, Mumbai, Pune, and nearby business locations."
  },
  {
    WhyChooseheading: "Flexible Corporate Travel Packages",
    WhyChoosedescription: "Get customized solutions including monthly contracts, employee transportation, point-to-point transfers, full-day rentals, and scheduled cab services based on your organization's requirements."
  },
  {
    WhyChooseheading: "Experienced Chauffeurs for Corporate Journeys",
    WhyChoosedescription: "Our trained drivers understand corporate travel expectations and provide punctual pickups, professional behaviour, safe driving, and smooth transportation for employees and business guests."
  },
  {
    WhyChooseheading: "Reliable Fleet Management & Clean Vehicles",
    WhyChoosedescription: "Every vehicle is regularly serviced, sanitized, air-conditioned, and inspected to maintain high standards of comfort, safety, and reliability for corporate travellers."
  },
  {
    WhyChooseheading: "Book Navi Mumbai Corporate Cab Service with Shreesha Travels",
    WhyChoosedescription: "Partner with Shreesha Travels for dependable corporate transportation, transparent pricing, professional chauffeur service, and customized cab solutions for your business needs."
  }
]

};

const faqData = [
  {
    question: "What is included in Navi Mumbai Corporate Cab Service?",
    answer: "Corporate cab services include employee transportation, executive travel, airport transfers, client pickups, business meetings, and customized travel solutions."
  },
  {
    question: "Do you provide employee pickup and drop services?",
    answer: "Yes, we provide scheduled employee transportation services with customized routes and timings according to company requirements."
  },
  {
    question: "Which vehicles are available for corporate cab booking?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, and premium vehicles."
  },
  {
    question: "Can companies book monthly corporate cab packages?",
    answer: "Yes, monthly and long-term corporate transportation packages are available for regular employee and business travel."
  },
  {
    question: "Do you provide airport transportation for corporate clients?",
    answer: "Yes, we offer airport pickup and drop services for executives, employees, clients, and business visitors."
  },
  {
    question: "Is corporate cab service available for business meetings?",
    answer: "Yes, our chauffeur-driven vehicles are available for meetings, conferences, corporate events, and client transportation."
  },
  {
    question: "Can I hire premium cars for VIP corporate guests?",
    answer: "Yes, premium vehicles including Innova Crysta and luxury options are available for VIP guests and executive travel."
  },
  {
    question: "How is corporate cab pricing decided?",
    answer: "Pricing depends on vehicle type, travel distance, service duration, number of employees, route planning, and customized corporate requirements."
  },
  {
    question: "Do you provide corporate cab services across Navi Mumbai and Mumbai?",
    answer: "Yes, we provide corporate transportation across Navi Mumbai, Mumbai, Thane, Pune routes, airports, business parks, and other locations."
  },
  {
    question: "How can I book Navi Mumbai Corporate Cab Service with Shreesha Travels?",
    answer: "Share your company requirements, employee count, routes, travel schedule, and preferred vehicles to receive a customized corporate transportation proposal."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Kulkarni",
    feedback: "Shreesha Travels provides excellent corporate cab service. Their drivers are punctual, vehicles are clean, and employee transportation is managed smoothly.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Riya Sharma",
    feedback: "We use their corporate cab service for regular business travel. The service is professional, reliable, and convenient for our team members.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Corporate Cab Service",
  "image": "https://www.shreeshatravels.com/assets/images/navi-mumbai-corporate-cab-service.webp",
  "description":
    "Book Navi Mumbai Corporate Cab Service with Shreesha Tours & Travels for professional and reliable corporate transportation solutions. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs with experienced chauffeurs for office travel, employee transportation, business meetings, corporate events, airport transfers, and long-distance corporate journeys with 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/navi-mumbai-corporate-cab-service"
  }
};





    return (
        <div>
<Helmet>
  <title>Navi Mumbai Corporate Cab Service | Business Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Navi Mumbai Corporate Cab Service with Shreesha Travels for safe and professional corporate taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta with experienced chauffeurs for office travel, employee transport, business meetings, airport transfers, and 24x7 corporate cab booking."
  />

  <meta
    name="keywords"
    content="Corporate Cab Service in Navi Mumbai, Corporate Taxi Service Navi Mumbai, Corporate Car Rental Navi Mumbai, Corporate Cab Booking Navi Mumbai, Navi Mumbai Office Cab Service, Corporate Travel Cab Navi Mumbai, Business Travel Cab Navi Mumbai, Company Cab Service Navi Mumbai, Corporate Chauffeur Navi Mumbai, Corporate Car Hire Navi Mumbai, Employee Transportation Navi Mumbai, Business Taxi Service Navi Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/106.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default NaviMumbaiCorporateCabService;